import React, { useEffect } from 'react'
import {connect} from 'react-redux'
import FormComponent from '../form/form.component'
import { createLoadingSelector } from '../../redux/loading/loading.selectors'
import DocumentDetailsComponent from '../document-details/document-details.component'
import WithSpinner from '../with-spinner/with-spinner.component'
import loadNIASScript from '../../utils/load-nias-script'


const loadingSelector = createLoadingSelector(['VALIDATE_DOCUMENT'])

const ValidateDocument = ({validation}) => {
   
  useEffect(() => {
    loadNIASScript(null, null)
  },[])

  return validation ? 
    <DocumentDetailsComponent validation={validation}/> :
    <FormComponent />
}

const mapStateToProps = (state) => {
  return {
    isLoading: loadingSelector(state),
    //error: errorSelector(state),
    validation: state.validation
  }
}

export default connect(mapStateToProps)(WithSpinner(ValidateDocument))
